/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function n(n2) {
  return n2;
}
const dynamicPhoneNumberContext = n("dynamic-phone-number");
const analyticsReadyContext = n("analytics-ready");
export {
  analyticsReadyContext,
  dynamicPhoneNumberContext
};
//# sourceMappingURL=phone-number-context.js.map
